import axios from 'axios'
import { EXCLUIR_DISPONIBILIDADE_VEICULO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function excluirDisponibilidadeVeiculo (disponibilidadeVeiculoId, empresaId) {
  let url = `${URL}/disponibilidade-veiculo/${disponibilidadeVeiculoId}/empresa/${empresaId}/excluir`;

  return dispatch => axios.post(url, null, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_DISPONIBILIDADE_VEICULO,
        payload: response
      })
  );
}
